/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import parse from 'html-react-parser';
import Title from '../shared/Title';
import DiagnosticTable from './DiagnosticTable';
import Benefits from './Benefits';
import Text from '../shared/Text';
import { palette } from '../../constants/styles';


const FinancialStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${palette.sweetGray};
  border-radius: 15px;
  width: 95%;
  padding: 5px 15px;
  margin-top: 50px;
  z-index: 300;
`;

const colorPalettes = [
  [palette.primaryColor, 'gray', palette.secondaryColor, palette.finautaOrange],
  [palette.sweetPurple],
  ['#de8244', '#f5c044', palette.terciaryColor, palette.sweetPurple],
];

function getDurationText(duration) {
  console.log(duration);
  let durationText = '';
  if (duration == -1) {
    durationText = 'De ahora en adelante';
  } else if (duration <= 24) {
    durationText = `${Math.ceil(duration)} meses`;
  } else {
    console.log(duration);
    const years = Math.floor(duration / 12);
    const months = Math.ceil((duration / 12 - years) * 12);
    durationText = `${years} años, ${months} meses`;
  }
  return durationText;
}

const Stats = ({
  number, benefitsIntro, duration, text, entries, identifier, title, linkText, colorPalette, email, planLink,
}) => (
  <FinancialStep>
    <Title level={4}>
        <b>Paso {number}:</b> <span style={{ fontWeight: '500' }}>{title}</span>
      </Title>
    <Text style={{ marginBottom: '0.5em' }}>
        <b>Duración:</b> {getDurationText(duration)}
      </Text>
    <Text style={{ marginBottom: '0.5em' }}>
        {parse(`${text}`)}
      </Text>
    <DiagnosticTable
        entries={entries}
        section="stepTwo"
        borderColor="#ddd"
        colorPalette={colorPalettes[colorPalette]}
      />
    {benefitsIntro !== '' && (<Text medium>{benefitsIntro}</Text>)}
    <Benefits
        entries={entries}
        colorPalette={colorPalettes[colorPalette]}
      />
    <Link
        to={`/contacto/plan/${identifier}/${planLink}`}
        style={{
          marginTop: '10px', marginBottom: '5px', cursor: 'pointer', alignSelf: 'center', textAlign: 'center', color: palette.terciaryColor, fontWeight: '500',
        }}
      >
        {linkText}
      </Link>
  </FinancialStep>
);

export default Stats;
